import React from 'react'
import NewsButton from '../container/newsButton'

/** Wrapper autour du bouton de news */
export default class News extends React.Component {

    render() {
        return (
            <div className="news-wrapper">
                <NewsButton />
            </div>
        )
    }
}